// Create and open the modal

function floowOpenModal(content) {
  const modal = document.querySelector(".floow-modal");

  if (!modal) {
    // If theres no modal container, create one and put it at the beginning of the body
    const modalText = `
      <div class="floow-modal">
        <div class="floow-modal-background" onclick="floowCloseModal();"></div>
        <div class="floow-modal-content-container">
          <svg 
            class="floow-modal-close"
            onclick="floowCloseModal()"
            role="presentation" stroke-width="2" focusable="false" width="24" height="24" viewBox="0 0 24 24">
              <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343"></path>
          </svg>
          <div class="floow-modal-content"></div>
        </div>
      </div>  
      `;
    const modalHTML = new DOMParser().parseFromString(modalText, "text/html");
    const modalElement = modalHTML.body.querySelector(".floow-modal");
    document.body.prepend(modalElement);
  }

  // Put the content in the modal
  const modalContent = document.querySelector(".floow-modal-content");
  modalContent.innerHTML = content.innerHTML;

  // Open the modal
  document.querySelector(".floow-modal").setAttribute("open", "");
}

// Close the modal

function floowCloseModal() {
  document.querySelector(".floow-modal").removeAttribute("open");
}

// Money formatting


function floowInitializeSlider(s, id) {
  const sliderWrapper = document.querySelector(`.slider-wrapper-${id}`);
  const slider = document.querySelector(`.slider-${id}`);
  const slides = Array.from(slider.children);
  const left = document.querySelector(`.left-arrow-${id}`);
  const right = document.querySelector(`.right-arrow-${id}`);
  let active = 0, autoSlideTimer = null, pauseTimer = null, isTouching = false;

  const isMobile = () => window.innerWidth <= s.mobile.width;
  const gap = () => isMobile() ? s.mobile.gap : s.gap;
  const spv = () => isMobile() ? s.mobile.slidesPerView : s.slidesPerView;
  const maxActive = () => slides.length - spv();
  const slideWidth = () => (slider.getBoundingClientRect().width - gap() * (spv() - 1)) / spv();
  const getOffset = (i) => i * (slideWidth() + gap());

  const scroll = (i) => {
    slider.style.transform = `translateX(-${getOffset(i)}px)`;
    if (s.showNav) {
      sliderWrapper.querySelectorAll(".floow-dot").forEach((d) => d.classList.toggle("floow-dot-active", d.getAttribute("dot-index") == i));
    }
  };

  const calc = () => {
    slides.forEach((slide) => (slide.style.width = `${slideWidth()}px`));
    slider.style.gap = `${gap()}px`;
    scroll(active);
  };

  calc();
  new ResizeObserver(calc).observe(slider);

  // Auto-slide state – hoisted here so touch handlers can access it too
  let manuallyStopped = false;
  const start = () => {
    if (!s.autoSlide || autoSlideTimer) return;
    autoSlideTimer = setInterval(() => {
      if (isTouching) return;   // finger still on screen – skip this tick
      active = active < maxActive() ? active + 1 : 0;
      scroll(active);
    }, s.autoSlide);
  };
  const stop = () => { clearInterval(autoSlideTimer); autoSlideTimer = null; };
  const pause = (duration) => {
    stop();
    clearTimeout(pauseTimer);
    pauseTimer = setTimeout(() => { if (!manuallyStopped) start(); }, duration);
  };

  left.addEventListener("click", () => { active = active > 0 ? active - 1 : maxActive(); scroll(active); });
  right.addEventListener("click", () => { active = active < maxActive() ? active + 1 : 0; scroll(active); });

  // Touch / Swipe Controls
  const SWIPE_THRESHOLD = 50;   // min px horizontal movement to trigger a slide
  const DRAG_THRESHOLD = 10;    // px before we decide it's a horizontal drag (not a scroll)

  let touchStartX = 0;
  let touchStartY = 0;
  let touchCurrentX = 0;
  let isDragging = false;
  let isHorizontal = null;      // null = undecided, true = horizontal drag, false = vertical scroll

  const sliderClip = document.querySelector(`.slider-clip-${id}`);

  sliderClip.addEventListener("touchstart", (e) => {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    touchCurrentX = touchStartX;
    isDragging = false;
    isHorizontal = null;
    isTouching = true;
    slider.style.transition = "none";
    // Stop auto-slide immediately while finger is on the slider
    if (s.autoSlide && !manuallyStopped) stop();
  }, { passive: true });

  sliderClip.addEventListener("touchmove", (e) => {
    const dx = e.touches[0].clientX - touchStartX;
    const dy = e.touches[0].clientY - touchStartY;
    touchCurrentX = e.touches[0].clientX;

    // Decide once: horizontal drag or vertical scroll?
    if (isHorizontal === null && (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD)) {
      isHorizontal = Math.abs(dx) > Math.abs(dy);
    }

    if (isHorizontal) {
      e.preventDefault();   // block page scroll while swiping the slider
      isDragging = true;
      // Live drag feedback: shift the slider as the finger moves
      const liveOffset = getOffset(active) - dx;
      slider.style.transform = `translateX(-${liveOffset}px)`;
    }
  }, { passive: false });

  sliderClip.addEventListener("touchend", () => {
    isTouching = false;
    slider.style.transition = "";   // re-enable CSS transition

    const delta = touchCurrentX - touchStartX;

    if (isDragging) {
      if (delta < -SWIPE_THRESHOLD) {
        active = active < maxActive() ? active + 1 : 0;
      } else if (delta > SWIPE_THRESHOLD) {
        active = active > 0 ? active - 1 : maxActive();
      }
      scroll(active);
    }

    // Resume auto-slide after a short pause (whether it was a swipe or just a tap)
    if (s.autoSlide && !manuallyStopped) pause(5000);
  }, { passive: true });

  sliderClip.addEventListener("touchcancel", () => {
    isTouching = false;
    slider.style.transition = "";
    scroll(active);   // snap back to current slide
    if (s.autoSlide && !manuallyStopped) start();
  }, { passive: true });

  if (s.autoSlide) {
    const playIcon = sliderWrapper.querySelector(".floow-slider-play");
    const pauseIcon = sliderWrapper.querySelector(".floow-slider-pause");

    const updateIcons = () => {
      if (!playIcon || !pauseIcon) return;
      playIcon.style.display = manuallyStopped ? "" : "none";
      pauseIcon.style.display = manuallyStopped ? "none" : "";
      pauseIcon.classList.toggle("paused", manuallyStopped);
    };

    if (playIcon) playIcon.addEventListener("click", (e) => { e.stopPropagation(); manuallyStopped = false; start(); updateIcons(); });
    if (pauseIcon) pauseIcon.addEventListener("click", (e) => { e.stopPropagation(); manuallyStopped = true; stop(); clearTimeout(pauseTimer); updateIcons(); });

    sliderWrapper.addEventListener("mouseenter", () => { if (!manuallyStopped) stop(); });
    sliderWrapper.addEventListener("mouseleave", () => { if (!manuallyStopped) start(); });
    sliderWrapper.addEventListener("click", () => { if (!manuallyStopped) pause(5000); });

    updateIcons();
    start();
  }

  if (s.showNav) {
    const navContainer = sliderWrapper.querySelector(".floow-dot-wrapper");
    slides.forEach((_, i) => {
      const e = document.createElement("div");
      e.classList.add("floow-dot");
      if (i === 0) e.classList.add("floow-dot-active");
      e.setAttribute("dot-index", i);
      e.addEventListener("click", () => { active = i; scroll(active); });
      navContainer.appendChild(e);
    });
  }
}




async function floowChangeVariant(productId, event, atcText, soldOutText) {
  const container = event.target.closest(`.floow-variant-picker-wrapper[product-id="${productId}"]`);
  const productData = JSON.parse(document.getElementById(`product-data-${productId}`).textContent);

  // 1. Gewählte Optionen sammeln
  const selectedOptions = [];
  container.querySelectorAll('.floow-variant-picker-value:checked').forEach((el) => {
    selectedOptions.push(el.value.trim());
  });

  // 2. Passende Variante finden
  const variant = productData.variants.find(v => {
    return v.options.every((opt, i) => opt === selectedOptions[i]);
  });

  if (!variant) {
    console.warn("Keine Variante gefunden für", selectedOptions);
    return;
  }

  // 3. Bild aktualisieren
  const imgEl = container.querySelector('.floow-variant-picker-image');
  if (variant.featured_image) {
    imgEl.src = variant.featured_image.src;
    imgEl.alt = variant.featured_image.alt || '';
  }

  // 4. Preis aktualisieren
  const priceEl = container.querySelector('.floow-variant-picker-price');
  priceEl.textContent = floowFormatMoney(variant.price);

  // Compare-at Preis
  const compareEl = container.querySelector('.floow-variant-picker-compare-at-price');
  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    compareEl.style.display = 'inline';
    compareEl.textContent = floowFormatMoney(variant.compare_at_price);
  } else {
    compareEl.style.display = 'none';
  }

  // 5. Add-to-Cart Button aktualisieren
  const atc = container.querySelector('.floow-variant-picker-atc');
  if (variant.available) {
    atc.classList.remove('floow-variant-picker-disabled');
    atc.innerText = atcText;
    atc.onclick = () => {
      floowAddToCart(variant.id, 1, atc);
      floowCloseModal();
      floowOpenCart();
    };
  } else {
    atc.classList.add('floow-variant-picker-disabled');
    atc.innerText = soldOutText;
    atc.onclick = null;
  }

 productData.options.forEach((optionName, optionIndex) => {
  const optionPos = optionIndex + 1; // Shopify Position = 1-basiert

  const allValues = [...new Set(productData.variants.map(v => v.options[optionIndex]))];

  allValues.forEach(value => {
    const input = container.querySelector(
      `.floow-variant-radio-${optionPos}[value="${CSS.escape(value)}"]`
    );
    if (!input) return;

    const possibleVariant = productData.variants.find(v => {
      return v.options[optionIndex] === value &&
             v.options.every((opt, i) => i === optionIndex || opt === selectedOptions[i]) &&
             v.available;
    });

    if (possibleVariant) {
  input.closest('label').classList.remove('floow-variant-picker-disabled');
} else {
  input.closest('label').classList.add('floow-variant-picker-disabled');
}

  });
});

}

async function floowRequestSection(string) { 
  const url = `${window.location.origin}/${string}`;
  const response = await fetch(url);
  const htmlString = await response.text();
  const html = new DOMParser().parseFromString(htmlString, "text/html");
  return html;
}


async function floowAddToCart(id, quantity) {

  const formData = {
    items: [
      {
        id: id,
        quantity: quantity
      }
    ]
  };

  const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  });

  const data = await response.json();
}

// Money formatting (EUR, de-DE). Cents -> "12,90 €".
function floowFormatMoney(cents) {
  try {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  } catch (e) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
}

// Refresh the theme cart (drawer / notification). Note: we intentionally dispatch only
// 'cart:refresh' — the theme's 'variant:add' handler expects a rendered 'variant-added'
// section in the event detail and throws without it.
async function floowOpenCart() {
  try {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  } catch (e) {
    window.location.href = '/cart';
  }
}

/* ---------------------------------------------------------------------------
   Floow Add-ons — shared registry + checkout bundling.
   Both the helmet add-on block and the warranty (subscription) block register
   their selection here. On checkout the main product + all selected add-ons are
   added together: the discount code is applied, and subscription lines carry
   their selling_plan (Appstle native selling plans).
--------------------------------------------------------------------------- */
window.FloowAddons = window.FloowAddons || (function () {
  var map = {};
  return {
    // id = variant id (unique key); data = { discount, mainProductId, sellingPlan, quantity }
    set: function (id, data, on) {
      if (on) { map[id] = Object.assign({ id: Number(id), quantity: 1 }, data || {}); }
      else { delete map[id]; }
    },
    getSelected: function () { return Object.keys(map).map(function (k) { return map[k]; }); },
    getDiscount: function () {
      var k = Object.keys(map);
      for (var i = 0; i < k.length; i++) { if (map[k[i]].discount) return map[k[i]].discount; }
      return '';
    },
    clear: function () { map = {}; }
  };
})();

(function () {
  if (window.__floowCheckoutBound) return;
  window.__floowCheckoutBound = true;

  document.addEventListener('submit', async function (e) {
    var form = e.target;
    // NOTE: form.id returns the <input name="id"> element on a product form -> read the attribute.
    var formId = (form && form.getAttribute) ? (form.getAttribute('id') || '') : '';
    if (formId.indexOf('product-form-') !== 0) return;

    var all = (window.FloowAddons && window.FloowAddons.getSelected) ? window.FloowAddons.getSelected() : [];
    if (!all.length) return;

    var pidMatch = formId.match(/^product-form-(\d+)-/);
    var pid = pidMatch ? Number(pidMatch[1]) : null;
    var addons = pid ? all.filter(function (a) { return !a.mainProductId || a.mainProductId === pid; }) : all;
    if (!addons.length) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var idInput = form.querySelector('[name="id"]');
    var mainId = idInput ? idInput.value : null;
    if (!mainId) { mainId = new FormData(form).get('id'); }

    // Each add-on (gift / subscription) is capped at 1 per add-on PRODUCT, regardless of variant.
    // Lines are marked with _floow_addon = <add-on product id> (the "group"). If another variant
    // of the same group is already in the cart we remove it (replace); the same variant is kept.
    // The line-item template also locks the quantity of these lines.
    var preItems = [];
    try { preItems = ((await (await fetch(root + 'cart.js')).json()).items) || []; } catch (e) {}

    var sameVariant = {}; // variant id already in cart for its group -> skip add
    var removeKeys = [];  // line keys of other variants of a group we're (re)adding -> remove

    addons.forEach(function (a) {
      var group = String(a.addonProductId || a.id);
      preItems.forEach(function (li) {
        if (!li.properties || String(li.properties._floow_addon) !== group) return;
        if (li.variant_id === a.id) { sameVariant[a.id] = true; }
        else { removeKeys.push(li.key); }
      });
    });

    // Remove superseded add-on variants first (replace behaviour).
    for (var ri = 0; ri < removeKeys.length; ri++) {
      try {
        await fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: removeKeys[ri], quantity: 0 })
        });
      } catch (e) {}
    }

    var items = [];
    if (mainId) items.push({ id: Number(mainId), quantity: 1 });
    addons.forEach(function (a) {
      if (sameVariant[a.id]) return; // same variant already in cart -> keep at 1
      var item = { id: a.id, quantity: 1, properties: { _floow_addon: String(a.addonProductId || a.id) } };
      if (a.sellingPlan) item.selling_plan = Number(a.sellingPlan); // subscription line (Appstle)
      items.push(item);
    });

    var headers = { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };

    async function addOne(item) {
      var r = await fetch(root + 'cart/add.js', { method: 'POST', headers: headers, body: JSON.stringify({ items: [item] }) });
      if (!r.ok) { var er = await r.json().catch(function () { return {}; }); console.warn('[Floow] Artikel nicht hinzugefügt:', item, er); return false; }
      return true;
    }

    try {
      // Request the 'variant-added' section AND every section the theme bundles
      // (e.g. the cart-drawer). The theme's own ProductForm dispatches
      // 'cart:prepare-bundled-sections' so the cart drawer can add its own section
      // id; without it the response lacks the drawer section and the cart never
      // re-renders. Mirror that behaviour here.
      // /cart/add.js is atomic: on failure add each item on its own so the main product still lands.
      var sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
      var addBody = { items: items, sections: sectionsToBundle.join(','), sections_url: root + 'variants/' + (mainId || '') };
      var res = await fetch(root + 'cart/add.js', { method: 'POST', headers: headers, body: JSON.stringify(addBody) });
      var responseJson = await res.json().catch(function () { return null; });

      if (!res.ok) {
        console.warn('[Floow] Bundle-Hinzufügen fehlgeschlagen, versuche einzeln:', responseJson);
        for (var i = 0; i < items.length; i++) { await addOne(items[i]); }
        responseJson = null;
      }

      var code = window.FloowAddons.getDiscount();
      if (code) { try { await fetch(root + 'discount/' + encodeURIComponent(code)); } catch (err) {} }

      var cart = await (await fetch(root + 'cart.js')).json();
      if (responseJson && responseJson.sections) {
        cart.sections = responseJson.sections;
        var addedItems = responseJson.items ? responseJson.items : [responseJson];
        document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: addedItems, cart: cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } catch (err) {
      console.error('[Floow] Checkout-Fehler:', err);
      window.location.href = '/cart';
    }
  }, true);
})();

/* Live-update the Checkout Info block on variant change (it is not in the theme's
   partial-rerender list, so we update it client-side from per-variant data). */
(function () {
  if (window.__floowCheckoutInfoBound) return;
  window.__floowCheckoutInfoBound = true;

  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant || variant.id == null) return;
    var vid = String(variant.id);

    document.querySelectorAll('[data-floow-checkout-info]').forEach(function (el) {
      var dataEl = el.querySelector('script.floow-cinfo-data');
      if (!dataEl) return;
      var map;
      try { map = JSON.parse(dataEl.textContent); } catch (err) { return; }
      var entry = map[vid];
      if (!entry) return;

      var mainEl = el.querySelector('.floow-checkout-info__main');
      var dotEl = el.querySelector('.floow-checkout-info__dot');
      var hlWrap = el.querySelector('.floow-checkout-info__hl-wrap');

      if (mainEl) mainEl.textContent = entry.text;
      if (dotEl) dotEl.style.background = entry.dot;
      if (hlWrap) hlWrap.style.display = entry.hl ? '' : 'none';
    });
  });
})();

function floowWaitForElement(selector) {
  return new Promise((resolve) => {

    const element = document.querySelector(selector);
    if (element) {
      resolve(element);
      return;
    }

    const observer = new MutationObserver(() => {
      const element = document.querySelector(selector);

      if (element) {
        resolve(element);
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

